<template>
    <v-list two-line dense v-if="$store.state.custFilter != ''">
        <template v-for="(item, index) in customers">
        <v-list-tile
            :key="item.title"
            avatar
            ripple
            @click="toggle(index)"
        >
            <v-list-tile-content>
            <v-list-tile-title>{{ item.Name }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ item.Name2 }}</v-list-tile-sub-title>
            <v-list-tile-sub-title class="text--primary">{{ item.alias }}</v-list-tile-sub-title>
            <v-list-tile-sub-title>{{ item.No }} - GP: {{item.CustomerPriceGroup}}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
            <v-list-tile-action-text><span v-if="item.discounts.discount != '0'">Dto {{ item.discounts.discount }}% - </span>Pago {{ item.Payment }}</v-list-tile-action-text>            
            <v-icon
                v-if="selected != index"
                color="grey lighten-1"
            >
                adjust
            </v-icon>

            <v-icon
                v-else
                color="yellow darken-2"
            >
                brightness_1
            </v-icon>
            </v-list-tile-action>

        </v-list-tile>
        <v-divider
            v-if="index + 1 < customers.length"
            :key="index"
        ></v-divider>
        </template>
    </v-list>
</template>
<script>
  export default {
      name: 'listaClientes',
    data () {
      return {        
      }
    },

    methods: {
      toggle (index) {
        this.selected = index;        
      }
    },
    computed: {
        customers: {
            get(){
                return this.$store.state.customers;
            }
        },
        selected: {
            get(){
                return this.$store.state.selectedCustIndex;
            },
            set(value){
                this.$store.commit('setSelectedCust',value);
            }
        }
    },
    mounted(){
        this.getCustomers();
    }
  }
</script>

